import ProductCard from "../ui/ProductCard";
import { useShop } from "../../context/ShopContext";

export default function ProductGrid(){

const{

filteredProducts

}=useShop();

return(

<div className="lg:col-span-3">

<div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3">

{

filteredProducts.map(product=>(

<ProductCard

key={product.id}

{...product}

/>

))

}

</div>

</div>

)

}